import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import ClientReportsPage from "@/pages/client/ClientReportsPage";

export const Route = createFileRoute("/client/contracts/$contractId/reports")({
  head: () => pageHead("Client · Contracts · Reports", "AKIVA client · contracts · reports portal.", "/client/contracts/$contractId/reports", true),
  component: ClientReportsPage,
});
